
import {
  defineComponent, shallowRef, onMounted, ref, watch, onUnmounted,
} from 'vue';
import * as echarts from 'echarts';

import {
  getGreenArea,
} from '../caronMonit';

export default defineComponent({
  setup () {
    // 是否有数据
    const isEmpty = ref(false);
    // 饼图
    const pieChart = shallowRef<any>({});

    // 饼图配置项
    const pieOption = {
      color: [
        '#CCE14C',
        '#8359F6',
        '#5B8AF7',
        '#59B7B9',
        '#7EE8FC',
        '#76D174',
        '#6E74F6',
        '#E6AA43',
        '#D285EE',
        '#F07B7B',
      ],
      legend: {
        icon: 'circle',
        orient: 'vertical',
        // right: 20,
        right: 80,
        top: 18,
        bottom: 20,
        height: 150,
        // 图例间距
        itemGap: 10,
        itemWidth: 18,
        inactiveBorderWidth: 0,
        inactiveBorderColor: 'white',
        itemHeight: 14,
        textStyle: {
          fontSize: 14,
          fontWeight: 400,
          fontFamily: 'Microsoft YaHei',
          // 主标题文字颜色
          color: 'rgba(68, 68, 68, 1)',
        },
      },
      series: {
        type: 'pie',
        radius: [50, 70,],
        left: '7%',
        width: 200,
        colorBy: 'data',
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1,
        },
        label: {
          show: false,
        },
        data: [],
      },
      tooltip: {
        show: true,
        formatter: (param: any) => {
          const {
            name, value, percent,
          } = param;

          return `<div><div style="font-weight:bold;">${name}</div>${value}公顷(${percent}%)</div>`;
        },
        textStyle: {
          align: 'left',
          fontSize: '16',
        },
      },
    };

    const initChart = () => {
      const pieChartContainer = document.getElementById('caron-green-chart') as HTMLElement;

      pieChart.value = echarts.init(pieChartContainer);
    };
    const drawChart = (data:any): void => {
      // 数据渲染
      pieOption.series.data = data;
      if (pieOption.series.data.length > 6) {
        pieOption.legend.right = 20;
      }
      pieChart.value.setOption(pieOption);
    };

    onMounted(() => {
      initChart();
      getGreenArea().then((res:any) => {
        if (res.length) {
          drawChart(res);
        } else {
          isEmpty.value = true;
        }
      });
    });
    onUnmounted(() => {
      echarts.dispose(pieChart.value);
      pieChart.value = null;
    });

    return {
      isEmpty,
    };
  },
});
